import { isIOS } from '../../utils/util';
import { commonBase } from '@ks/kwcolor/color/output/common/index';
/* 二级尺寸 */
// 字号
export const font_grade_1 = 24; /* 页面大标题、大数字、结果等信息等 */
export const font_grade_2 = 20; /* 弹层组件选中态、数据披露 */
export const font_grade_3 = 18; /* 顶部三大Tab、弹窗标题 */
export const font_grade_4 = 17; /* 卡片标题、二级页面标题、文字按钮 */
export const font_grade_5 = 16; /* 强调文本、弹层文本、大按钮文本等 */
export const font_grade_6 = 15; /* 列表文本、小标题、中按钮文本 */
export const font_grade_7 = 14; /* 描述段落文本、中按钮文本 */
export const font_grade_8 = 12; /* 辅助信息、小按钮文本 */
export const font_grade_9 = 11; /* 基准标签文字 */
export const font_grade_10 = 10; /* 最小次级信息 */
export const font_grade_11 = 9; /* 小号标签文字 */
export const font_grade_12 = 7; /* 状态标签文字 */
// 行高
export const line_height_grade_1 = 34; /* 页面大标题、大数字、结果等信息等 */
export const line_height_grade_2 = 28; /* 弹层组件选中态、数据披露 */
export const line_height_grade_3 = 26; /* 顶部三大Tab、弹窗标题 */
export const line_height_grade_4 = 25; /* 卡片标题、二级页面标题、文字按钮 */
export const line_height_grade_5 = 24; /* 强调文本、弹层文本、大按钮文本等 */
export const line_height_grade_6 = 23; /* 列表文本、小标题、中按钮文本 */
export const line_height_grade_7 = 21; /* 描述段落文本、中按钮文本 */
export const line_height_grade_8 = 18; /* 辅助信息、小按钮文本 */
export const line_height_grade_9 = 16; /* 基准标签文字 */
export const line_height_grade_10 = 15; /* 最小次级信息 */
export const line_height_grade_11 = 14; /* 小号标签文字 */
export const line_height_grade_12 = 10; /* 状态标签文字 */
// 字重
export const font_weight_medium = '500';
export const font_weight_normal = '400';
export const font_weight_bold = '500';
/* 三级尺寸 */
/* switch */
export const switch_size_width = 46;
export const switch_size_height = 24;
export const switch_size_text_label = font_grade_5;
export const switch_label_left_margin = 10;
/* tooltip组件 */
export const tooltip_size_text = font_grade_7; /* tip泡泡中的文字尺寸 */
export const tooltip_size_line_height = line_height_grade_7; /* tip泡泡中的文字行高 */
export const tooltip_size_container_horizontal_padding = 16; /* tip泡泡中的水平padding */
export const tooltip_size_container_vertical_padding = 8; /* tip泡泡中的垂直padding */
export const tooltip_size_container_border_radius = 4; /* tip泡泡的圆角大小 */
export const tooltip_size_container_arrow_half_width = 5; /* tip泡泡的箭头的一半宽度 */
/* icon 组件 */
export const icon_img_width = 24; /* icon中的图片宽度 */
export const icon_img_height = 24; /* icon中的图片高度 */
/* checkbox组件 */
export const checkbox_size_icon = 20; /* checkbox中选中图标的icon/数字类型时内部文字的尺寸 */
export const checkbox_size_container_width = 20; /* checkbox容器宽度 */
export const checkbox_size_container_height = 20; /* checkbox容器高度 */
export const checkbox_size_text_container_width = 20; /* checkbox数字类型文字容器宽度 */
export const checkbox_size_text_container_height = 20; /* checkbox数字类型文字容器高度 */
export const checkbox_size_text_label = font_grade_5; /* checkbox中label文字字号 */
export const checkbox_size_line_height_label = line_height_grade_5; /* checkbox中label文字行高 */
export const checkbox_size_number_text = font_grade_8; /* checkbox中Number类型时的文字字号 */
export const checkbox_label_margin = 8; /* checkbox中label文字与radio的间距 */
/* radio组件 */
export const radio_size_icon = 20; /* radio中选中图标的icon/数字类型时内部文字的尺寸 */
export const radio_size_container_width = 20; /* radio容器宽度 */
export const radio_size_container_height = 20; /* radio容器高度 */
export const radio_size_text_label = font_grade_5; /* radio中label文字字号 */
export const radio_size_line_height_label = line_height_grade_5; /* radio中label文字行高 */
export const radio_label_margin = 8; /* radio中label文字与radio的间距 */
/* notice-bar 组件 */
export const notice_bar_size_height = 40; /* notice-bar 高度 */
export const notice_bar_size_padding_vertical = 10; /* notice-bar 内容上下间距 */
export const notice_bar_size_padding_horizontal = 19; /* notice-bar 内容左右间距 */
export const notice_bar_size_padding_horizontal_round = 16; /** notice bar round 内容左右间距 */
export const notice_bar_size_text_font_size = font_grade_7; /* notice-bar 内容字号 */
export const notice_bar_size_text_line_height = line_height_grade_7; /* notice-bar 内容行高 */
export const notice_bar_size_border_radius = 8; /* notice-bar 圆角大小 */
export const notice_bar_size_content_left_margin = 4;
export const notice_bar_size_content_right_margin = 16;
export const notice_bar_icon_size = 16;
/* dialog 组件 */
export const dialog_size_width = 280; /* 弹窗宽度 */
export const dialog_size_border_radius = 12; /* 弹窗圆角 */
export const dialog_size_body_padding = 24; /* 弹窗padding */
export const dialog_size_content_padding_top = 12; /* 弹窗padding */
export const dialog_size_header_font_size = font_grade_3; /* 弹窗标题字号 */
export const dialog_size_header_line_height = line_height_grade_3; /* 弹窗标题行高 */
export const dialog_size_header_font_weight = font_weight_bold; /* 弹窗标题字重 */
export const dialog_size_content_font_size = font_grade_5; /* 弹窗内容字号 */
export const dialog_size_content_line_height = line_height_grade_5; /* 弹窗内容行高 */
export const dialog_size_content_font_weight = font_weight_normal; /* 弹窗内容字重 */
export const dialog_size_action_font_size = font_grade_4; /* 弹窗按钮字号 */
export const dialog_size_action_line_height = line_height_grade_4; /* 弹窗按钮行高 */
export const dialog_size_action_font_weight = font_weight_normal; /* 弹窗按钮字重 */
export const dialog_size_action_height = 48; /* 弹窗操作区域高度 */
export const dialog_button_padding_vertical = 12; /* 按钮文案上下间距 */
export const dialog_button_padding_horizontal = 10; /* 按钮文案左右间距 */
/* toast 组件 */
export const toast_size_container_width = 120;
export const toast_size_info_container_min_width = 120;
export const toast_size_info_container_max_width = 240;
export const toast_size_container_height = 120;
export const toast_size_gap_icon_content = 11;
export const toast_size_info_padding_vertical = 12;
export const toast_size_info_padding_horizontal = 20;
export const toast_size_normal_padding_vertical = 20;
export const toast_size_normal_padding_horizontal = 11;
export const toast_size_icon = 48;
export const toast_size_normal_text = font_grade_7;
export const toast_size_info_text = font_grade_5;
export const toast_size_normal_line_height = line_height_grade_7;
export const toast_size_info_line_height = line_height_grade_5;
export const toast_size_container_border_radius = 8;
export const toast_size_text_margin_top = 7;
/* empty-state 组件 */
export const empty_state_size_padding = 48; /* empty-state 标题字号 */
export const empty_state_size_title_font_size = font_grade_3; /* empty-state 标题字号 */
export const empty_state_size_title_line_height = line_height_grade_3; /* empty-state 标题行高 */
export const empty_state_size_description_font_size = font_grade_6; /* empty-state 描述字号 */
export const empty_state_size_description_line_height = line_height_grade_6; /* empty-state 描述行高 */
export const empty_state_size_link_font_size = 13; /* empty-state 链接字号 */
export const empty_state_size_link_line_height = 22; /* empty-state 链接行高 */
/* picker组件 */
export const picker_size_title_bar_height = 56; /* picker title-bar 高度 */
export const picker_size_scroll_container_height = 260; /* picker 滚动区域高度 */
export const picker_size_scroll_item_height = 56; /* picker 单个项高度 */
export const picker_size_scroll_top_bottom_height = 102; /* picker 容器上方/下方留白高度 */
export const picker_size_clickable_text = font_grade_5; /* 可点击文字字号 */
export const picker_size_title_text = font_grade_4; /* 顶部title字号 */
export const picker_size_scroll_item_normal_text = font_grade_5; /* 可滑动item未选中字号 */
export const picker_size_scroll_item_selected_text = font_grade_2; /* 可滑动item选中时字号 */
/* input组件 */
export const input_size_container_default_width = '100%';
export const input_size_container_mini_height = 24;
export const input_size_container_small_height = 56;
export const input_size_container_large_height = 60;
export const input_size_font = font_grade_5;
export const input_size_arrow = 16;
export const input_size_clear = 20;
export const input_size_line_height = line_height_grade_5;
export const input_size_icon_height = 16;
export const input_size_icon_width = 16;
export const input_size_icon_margin_left = 12;
export const input_size_border_width = 1;
/* textarea组件 */
export const textarea_size_container_default_width = '100%';
export const textarea_size_container_default_height = 118;
export const textarea_size_container_default_line_height = 20;
export const textarea_size_counter_height = 20;
export const textarea_size_counter_margin_top = 2;
export const textarea_size_padding_left = 12;
export const textarea_size_padding_right = 12;
export const textarea_size_padding_top = 8;
export const textarea_size_padding_bottom = 8;
export const textarea_size_border_radius = 4;
export const textarea_size_border_width = 1;
/** switch组件 */
export const switch_size_container_default_width = 48;
export const switch_size_container_default_height = 26;
export const switch_size_thumb_border_width = 1;
/* form-item组件 */
export const formItemTokenSizeContainerNormalMinHeight = 56;
export const formItemTokenSizeContainerLargeMinHeight = 60;
export const formItemTokenSizeLabelWidth = 88;
export const formItemTokenSizeLabelFont = 16;
export const formItemTokenSizeLineHeight = 24;
export const formItemTokenSizePadding = 19;
/* ActionSheet组件 */
export const action_sheet_size_title = font_grade_7; // 标题文字大小
export const action_sheet_size_text = font_grade_4; // 选项文字大小
export const action_sheet_size_option_height = 64; // 选项高度
/* navBar组件 */
// 导航栏高度
export const navBarTokenSizeHeightBar = 45;
// 导航栏字体大小
export const navBarTokenSizeTitleFont = font_grade_4;
// 按钮文字尺寸
export const navBarTokenSizeTextFont = font_grade_4;
// 按钮icon尺寸
export const navBarTokenSizeIconFont = 19; // var(--font-grade-4 + 2px)
// 左右按钮高度
export const navBarSizeBtn = 40;
/* image-preview 组件 */
// 分页指示器区域高度
export const imagePreviewTokenSizeIndicatorHeight = 56;
// 分页指示器字号
export const imagePreviewTokenSizeIndicatorFontSize = font_grade_5;
/* Stepper组件 */
export const stepper_size_number = font_grade_6; // 数字字体大小
export const stepper_size_icon = 17; // 加减icon字体大小 var(font_grade_6 + 2px)
export const stepper_size_width_press_area = 35; // 加减icon点击区域宽度
export const stepper_size_height = 32; // 组件高度(normal)
export const stepper_size_height_small = 28; // 组件高度(small)
export const stepper_size_input_width = 36; // 数字框默认宽度
export const stepper_size_number_border = 4; // 数字框边框半径
export const stepper_size_number_padding_horizontal = 9; // 数字框横向padding
/* SwipeCell组件 */
export const swipe_cell_size_text = font_grade_7; // 按钮文字尺寸
export const swipe_cell_size_btn_min_width = 52; // 按钮最小宽度
/* textarea组件 */
export const textarea_size_font = font_grade_5;
export const textarea_size_line_height = 20;
/* uploader 组件 */
export const uploader_size_width = 88; /* 上传卡片宽度 */
export const uploader_size_height = 88; /* 上传卡片高度 */
export const uploader_size_border_radius = 8; /* 上传卡片圆角 */
export const uploader_size_icon = 24; /* 上传卡片图标尺寸 */
export const uploader_size_text_font_size = font_grade_8; /* 上传卡片文案字号尺寸 */
export const uploader_size_text_line_height = line_height_grade_8; /* 上传卡片文案行高尺寸 */
export const uploader_size_card_padding = 8; /* 上传卡片文案行高尺寸 */
/* bottom-panel 组件 */
export const bottom_panel_size_border_radius = 16; // 圆角大小
export const bottom_panel_size_header_font_size = font_grade_2; // 标题字号
export const bottom_panel_size_header_line_height = line_height_grade_2; // 标题行高
export const bottom_panel_size_header_font_weight = font_weight_medium; // 标题字重
export const bottom_panel_size_content_font_size = font_grade_6; // 内容字号
export const bottom_panel_size_content_line_height = line_height_grade_6; // 内容行高
/* bottom-dialog 组件 */
export const bottom_dialog_size_header_font_size = font_grade_2; // 标题字号
export const bottom_dialog_size_header_line_height = line_height_grade_2; // 标题行高
export const bottom_dialog_size_header_font_weight = font_weight_medium; // 标题字重
export const bottom_dialog_size_content_font_size = font_grade_6; // 内容字号
export const bottom_dialog_size_content_line_height = line_height_grade_6; // 内容行高
export const bottom_dialog_size_container_border_radius = 32; // 弹窗圆角大小
/* tabs 组件 */
export const tab_size_text = font_grade_6; /* 标签栏字体大小 */
export const tab_size_text_primary = font_grade_5; /* 一级标签栏字体大小 */
export const tab_size_text_primary_half = font_grade_5; /* 半屏标签栏字体大小 */
export const tab_size_text_secondary = font_grade_7; /* 二级标签栏字体大小 */
export const tab_size_text_weight = font_weight_normal; //未激活字体粗细
export const tab_size_text_active_weight = font_weight_bold; //激活字体粗细
export const tab_size_tab_bar_height = 38; /* 标签栏高度 */
export const tab_size_tab_bar_height_primary = 44; /* 一级标签栏高度 */
export const tab_size_tab_bar_height_primary_half = 48; /* 半屏标签栏高度 */
export const tab_size_tab_bar_height_secondary = 38; /* 二级标签栏高度 */
export const tab_size_slider_height = 2; /* 标签栏slider高度 */
export const tab_size_slider_border_radius = 1; /* 标签栏slider边框圆角 */
// /** button 组件 */
export const button_size_icon_margin_right = 4;
export const button_size_icon_width = {
    tiny: font_grade_7,
    mini: font_grade_5,
    small: font_grade_5,
    medium: font_grade_5,
    large: font_grade_1,
    huge: font_grade_1,
};
// Badge组件
export const badge_size_padding_horizontal = {
    number: 4,
    text: 4,
    dot: 3,
    warn: 4,
};
export const badge_title_font_size = {
    text_small: 7,
    text_large: 10,
    number_small: 12,
    number_large: 12,
};
// 徽标高度
export const badge_size_height = {
    text_small: 11,
    text_large: 16,
    dot_small: 6,
    dot_large: 8,
    warn_small: 16,
    warn_large: 24,
    number_small: 16,
    number_large: 16,
};
// 徽标边框大小
export const badge_size_border_width = {
    number: 1,
    text: 1,
    dot: 2,
    warn: 1,
};
// 徽标警告图标宽度
export const badge_size_warn_icon_width = {
    small: 1.5,
    large: 2.5,
};
// 徽标警告图标高度
export const badge_size_warn_icon_height = {
    small: 8.5,
    large: 14,
};
export const badge_size_warn_icon_size = 9;
export const loading_size = 40; /* loading尺寸 */
// 导航组件
export const nav_bar_size_text_font_size = font_grade_4;
export const nav_bar_size_title_font_size = font_grade_3;
export const nav_bar_text_font_weight = font_weight_normal;
export const nav_bar_title_font_weight = font_weight_bold;
// 搜索栏组件
export const searchbar_size_input_height = 40;
export const searchbar_size_input_padding_horizontal = 12;
export const searchbar_size_left_content_margin_right = 18;
export const searchbar_size_input_content_margin = 12;
export const searchbar_size_right_content_text = 16;
export const searchbar_size_search_icon = 16;
export const searchbar_size_right_icon = 20;
export const searchbar_size_input_icon_margin = 5;
export const searchbar_size_input_font = 16;
/* FormItem 组件 */
export const formitem_padding = 19; // 容器左右padding
export const formitem_size_small_min_height = 56; // 小尺寸的最小高度
export const formitem_size_large_min_height = 60; // 大尺寸的最小高度
export const formitem_label_width = 80; // 左侧标题容器的宽度
export const formitem_label_margin_right = 16; // 左侧标题容器的右边距
export const formitem_label_font = font_grade_5; // 标题字体大小
export const formitem_line_height = line_height_grade_5; // 行高
export const formitem_content_margin_top = 16; // content上边距
export const formitem_vertical_padding = 16; // 容器最小上下边距
export const formitem_sub_title_font = font_grade_8; // 副标题字体大小
export const formitem_sub_title_line_height = line_height_grade_9; // 副标题字体行高
export const formitem_red_point_size = 4; // require红点大小
export const formitem_red_point_margin_left = 3; // require红点左边距
export const formitem_message_font = font_grade_8; // 错误信息提示字体大小
export const formitem_message_line_hight = line_height_grade_8; // 错误信息提示行高
export const formitem_size_border_width = 0.5; // 边框宽度
// FormItem大小，minHeight
export const form_item_size_min_height = {
    small: formitem_size_small_min_height,
    large: formitem_size_large_min_height,
};
// 骨架屏组件
export const skeleton_size_line_height = font_grade_6;
export const skeleton_size_line_margin_vertical = 4;
export const skeleton_size_line_border_radius = 2;
export const skeleton_size_title_height = font_grade_1;
export const skeleton_size_title_margin_vertical = 12;
export const skeleton_size_title_border_radius = 4;
// 头像组件
export const avatar_size_diameter = 48;
export const avatar_size_border_width = 0;
export const avatar_group_size_offset_x = 30;
export const avatar_group_size_offset_y = 0;
// 分割线
export const getComponentsGlobalStyle = (colorConfig) => {
    const { cs_common_background_main, cs_common_background_float_primary, cs_common_text_main, cs_common_text_title, cs_common_stroke_primary, cs_common_text_mainbutton, cs_common_background_surface_primary, cs_common_background_divider_primary, cs_common_background_divider_secondary, cs_common_text_black, cs_common_stroke_secondary3, cs_common_tint_main, cs_common_background_switch, cs_common_tint_white, cs_common_text_hintsafety, cs_common_text_orange1, cs_common_text_red_error, cs_common_background_lablefour, cs_common_background_label_bg2, cs_common_background_labelbackgroundcolor, cs_common_background_toast, cs_common_text_dialog_text1, cs_common_stroke_dialogline, cs_common_text_primary, cs_common_background_labletwo, cs_common_text_secondary, cs_common_text_least, cs_common_background_secondary, cs_common_background_shallowblack, cs_common_tint_black, cs_common_background_primary, cs_common_tint_red, cs_common_stroke_primary_4, } = colorConfig;
    return {
        button: {
            // 按钮高度
            button_tiny_size_height: 28,
            button_mini_size_height: 32,
            button_small_size_height: 36,
            button_medium_size_height: 40,
            button_large_size_height: 48,
            button_huge_size_height: 56,
            // 按钮内边距
            button_tiny_size_padding_horizontal: 12,
            button_mini_size_padding_horizontal: 12,
            button_small_size_padding_horizontal: 12,
            button_medium_size_padding_horizontal: 16,
            button_large_size_padding_horizontal: 24,
            button_huge_size_padding_horizontal: 32,
            // 按钮文本字体大小
            button_tiny_title_font_size: font_grade_8,
            button_mini_title_font_size: font_grade_8,
            button_small_title_font_size: font_grade_7,
            button_medium_title_font_size: font_grade_7,
            button_large_title_font_size: font_grade_6,
            button_huge_title_font_size: font_grade_5,
            // 按钮文本行高
            button_tiny_title_line_height: 17,
            button_mini_title_line_height: 17,
            button_small_title_line_height: 20,
            button_medium_title_line_height: 20,
            button_large_title_line_height: 21,
            button_huge_title_line_height: 22,
            // 按钮边框宽度
            button_border_width: 1,
            // 按钮圆角
            button_tiny_size_border_radius: 999,
            button_mini_size_border_radius: 999,
            button_small_size_border_radius: 999,
            button_medium_size_border_radius: 999,
            button_large_size_border_radius: 999,
            button_huge_size_border_radius: 999,
            // 按钮边框颜色
            button_primary_border_color: cs_common_background_main,
            button_plain_border_color: cs_common_stroke_primary,
            button_ghost_border_color: cs_common_background_main,
            // 按钮背景色
            button_primary_background_color: cs_common_background_main,
            button_plain_background_color: cs_common_background_float_primary,
            button_ghost_background_color: 'transparent',
            // 按钮文本颜色
            button_primary_title_color: cs_common_text_mainbutton,
            button_plain_title_color: cs_common_text_title,
            button_ghost_title_color: cs_common_text_main,
            // 按钮icon颜色
            button_primary_icon_color: cs_common_text_mainbutton,
            button_plain_icon_color: cs_common_text_title,
            button_ghost_icon_color: cs_common_text_main,
            // 按钮文本加粗
            button_title_font_weight: 'bold',
        },
        cascade: {
            cascade_size_selected_height: 44,
            cascade_size_selected_font: 14,
            cascade_size_selected_icon_margin_left: 12,
            cascade_size_list_item_height: 44,
            cascade_size_list_item_border_width: 0.5,
            cascade_size_selected_icon_custom: 12,
            cascade_size_border_radius: 16,
            cascade_size_padding_horizontal: 19,
            cascade_size_height: 672,
            cascade_size_header_height: 25,
            cascade_size_header_margin_vertical: 16,
            cascade_size_header_text: 17,
            cascade_size_list_item_font: 14,
            // 颜色变量
            cascade_color_selected_text: cs_common_text_title,
            cascade_color_list_item_font: cs_common_text_title,
            cascade_color_selected_active_text: cs_common_text_main,
            cascade_color_selected_icon: cs_common_text_main,
            cascade_color_list_item_border: cs_common_background_divider_secondary,
            cascade_color_background: cs_common_background_surface_primary,
            cascade_color_header_text: cs_common_text_title,
        },
        // 消息通知栏
        snackbar: {
            // 尺寸变量
            snackbar_size_left_icon_notification: 16,
            snackbar_size_left_icon_functional: 28,
            snackbar_size_right_arrow_icon: 16,
            snackbar_size_padding_horizontal: 12,
            snackbar_size_icon_margin_right: 8,
            snackbar_size_border_radius: 12,
            snackbar_size_padding_vertical_functional: 16,
            snackbar_size_padding_vertical_notification: 18,
            snackbar_size_content_fontsize: 14,
            snackbar_size_title_fontsize: 15,
            // 颜色变量
            snackbar_color_background: cs_common_background_float_primary,
            snackbar_color_left_icon: cs_common_text_title,
            snackbar_color_title: cs_common_text_title,
            snackbar_color_content: cs_common_text_title,
            snackbar_color_right_arrow_icon: cs_common_text_title,
            snackbar_color_right_text: cs_common_text_title,
        },
        // 选择器
        // picker
        picker: {
            // 尺寸变量
            picker_size_title_bar_height: 56 /* picker title-bar 高度 */,
            picker_size_scroll_container_height: 260 /* picker 滚动区域高度 */,
            picker_size_scroll_item_height: 56 /* picker 单个项高度 */,
            picker_size_scroll_top_bottom_height: 102 /* picker 容器上方/下方留白高度 */,
            picker_size_clickable_text: font_grade_5 /* 可点击文字字号 */,
            picker_bottom_gap_height: isIOS ? 34 : 16 /* 底部内边距 */,
            picker_size_title_text: font_grade_4 /* 顶部title字号 */,
            picker_size_scroll_item_normal_text: font_grade_5 /* 可滑动item未选中字号 */,
            picker_size_scroll_item_selected_text: font_grade_2 /* 可滑动item选中时字号 */,
            // 颜色变量
            picker_color_title_color: cs_common_text_title,
            picker_view_background_color: cs_common_background_surface_primary,
            picker_view_item_font_color: cs_common_text_black,
            picker_view_mask_background_color: cs_common_background_surface_primary,
            picker_view_mask_border_color: cs_common_stroke_primary_4,
            picker_cancel_text_color: cs_common_text_primary,
            picker_finish_text_color: cs_common_text_main,
            picker_title_bar_background_color: cs_common_background_surface_primary,
            picker_bottom_gap_background_color: cs_common_background_surface_primary,
        },
        // 单选框
        radio: {
            // 尺寸变量
            radio_size_container_width_custom: 20,
            radio_size_container_height_custom: 20,
            radio_size_text_label: font_grade_5,
            radio_size_line_height_label: line_height_grade_5,
            radio_label_margin: 8,
            radio_label_font_weight: font_weight_normal,
            // 颜色变量
            radio_label_text_color: cs_common_text_black,
            radio_icon_color: cs_common_stroke_secondary3,
            radio_active_icon_color: cs_common_tint_main,
            // 没用到
            radio_icon_size_custom: 20,
            radio_background_diable_color: cs_common_background_switch,
            radio_active_background_color: cs_common_tint_main,
            radio_fill_active_color: cs_common_tint_white,
        },
        // 通告栏
        noticebar: {
            // 尺寸变量
            notice_bar_size_height: notice_bar_size_height,
            notice_bar_size_padding_horizontal_round: notice_bar_size_padding_horizontal_round,
            notice_bar_size_padding_horizontal: notice_bar_size_padding_horizontal,
            notice_bar_font_size: font_grade_7,
            notice_bar_size_content_left_margin: notice_bar_size_content_left_margin,
            notice_bar_size_content_right_margin: notice_bar_size_content_right_margin,
            notice_bar_size_border_radius: notice_bar_size_border_radius,
            notice_bar_size_text_line_height: notice_bar_size_text_line_height,
            notice_bar_size_padding_vertical: notice_bar_size_padding_vertical,
            notice_bar_icon_size_custom: notice_bar_icon_size,
            // 颜色
            notice_bar_text_color_default: cs_common_text_main,
            notice_bar_text_color_safe: cs_common_text_hintsafety,
            notice_bar_text_color_warning: cs_common_text_orange1,
            notice_bar_text_color_error: cs_common_text_red_error,
            notice_bar_bg_color_default: cs_common_background_labletwo,
            notice_bar_bg_color_safe: cs_common_background_lablefour,
            notice_bar_bg_color_error: cs_common_background_label_bg2,
            notice_bar_bg_color_warning: cs_common_background_labelbackgroundcolor,
        },
        // 提示
        toast: {
            // color
            toast_color_background: cs_common_background_toast,
            toast_color_text: cs_common_text_mainbutton,
            // size
            toast_size_info_padding_vertical: toast_size_info_padding_vertical,
            toast_size_info_padding_horizontal: toast_size_info_padding_horizontal,
            toast_size_normal_padding_vertical: toast_size_normal_padding_vertical,
            toast_size_normal_padding_horizontal: toast_size_normal_padding_horizontal,
            toast_size_normal_text: toast_size_normal_text,
            toast_size_info_text: toast_size_info_text,
            toast_size_normal_line_height: toast_size_normal_line_height,
            toast_size_info_line_height: toast_size_info_line_height,
            toast_size_container_border_radius: toast_size_container_border_radius,
            toast_size_icon_custom: toast_size_icon,
            toast_size_container_width: toast_size_container_width,
            toast_size_info_container_min_width: toast_size_info_container_min_width,
            toast_size_info_container_max_width: toast_size_info_container_max_width,
            toast_size_text_margin_top: toast_size_text_margin_top,
        },
        // 加载
        loading: {
            // 尺寸变量
            loading_size: loading_size,
        },
        // 弹窗
        dialog: {
            // 颜色变量
            dialog_color_title_color: cs_common_text_title,
            dialog_color_background: cs_common_background_float_primary,
            dialog_color_content_color: cs_common_text_dialog_text1,
            dialog_color_divider_color: cs_common_stroke_dialogline,
            dialog_color_confirm_color: cs_common_text_hintsafety,
            dialog_color_cancel_color: cs_common_text_primary,
            // 尺寸变量
            dialog_size_width: dialog_size_width,
            dialog_size_border_radius: dialog_size_border_radius,
            dialog_size_body_padding: dialog_size_body_padding,
            dialog_size_content_padding_top: dialog_size_content_padding_top,
            dialog_size_header_font_size: dialog_size_header_font_size,
            dialog_size_header_line_height: dialog_size_header_line_height,
            dialog_weight_header_font_weight: dialog_size_header_font_weight,
            dialog_size_content_font_size: dialog_size_content_font_size,
            dialog_size_content_line_height: dialog_size_content_line_height,
            dialog_size_content_font_weight: dialog_size_content_font_weight,
            dialog_size_action_font_size: dialog_size_action_font_size,
            dialog_size_action_height: dialog_size_action_height,
            dialog_button_padding_vertical: dialog_button_padding_vertical,
            dialog_button_padding_horizontal: dialog_button_padding_horizontal,
            dialog_align_content_align: 'center',
            // 没用到
            dialog_color_delete_color: cs_common_text_main,
            dialog_size_action_line_height: dialog_size_action_line_height,
            dialog_size_action_font_weight: dialog_size_action_font_weight,
            line_count: 9, // 代码里通过默认值写死了
        },
        // 勾选
        checkbox: {
            checkbox_size_text_label: 16,
            checkbox_size_line_height_label: 24,
            checkbox_label_text_color: cs_common_text_black,
            checkbox_label_font_weight: 'normal',
            checkbox_icon_color: cs_common_stroke_secondary3,
            checkbox_active_icon_color: cs_common_tint_main,
            checkbox_number_text_color: '#fff',
            checkbox_label_margin: 8,
            checkbox_size_number_icon_width: 20,
            checkbox_size_number_icon_height: 20,
            // 传给Icon组件的customStyle
            checkbox_icon_size_custom: 20,
            checkbox_size_container_width_custom: 20,
            checkbox_size_container_height_custom: 20,
            // 没用到
            checkbox_fill_active_color: cs_common_tint_white,
            checkbox_active_background_color: cs_common_tint_main,
            checkbox_background_diable_color: cs_common_background_switch,
        },
        selector: {
            // 容器上下间距固定为24px
            selector_size_container_padding: 24,
            // 选项卡label字体大小
            selector_size_label_font_size: font_grade_6,
            // 选项卡desc字体大小
            selector_size_description_font_size: font_grade_8,
            // 选项卡label行高
            selector_size_label_line_height: line_height_grade_7,
            // 选项卡desc行高
            selector_size_description_line_height: 17,
            // 选项卡边框宽度
            selector_size_option_border_width: 0.5,
            // 选项卡边框圆角
            selector_size_option_border_radius: 4,
            // 选项卡左右外边距
            selector_size_option_margin_x: 8,
            // 选项卡上下外边距（不合并同上）
            selector_size_option_margin_y: 12,
            // 选项卡padding
            selector_size_option_padding_y: 7.5,
            // 选项卡边框色
            selector_color_option_borderColor: cs_common_stroke_primary,
            // 选项卡文字色
            selector_color_option_color: cs_common_text_title,
            // 选项卡desc文字色
            selector_color_description_color: cs_common_text_secondary,
            // 选项卡选中状态背景色（默认）
            selector_color_option_selected_background: cs_common_background_labletwo,
            // 选项卡被选中时文字色（默认）
            selector_color_option_selected_color: cs_common_text_main,
            // 选项卡被选中时边框色（默认）
            selector_color_option_selected_borderColor: commonBase.color_base_red_21_a30,
            // 禁用状态文字色
            selector_color_option_disabled_color: cs_common_text_least,
            // 选择组容器背景色
            selector_color_container_background: cs_common_background_float_primary,
            // 选项卡背景色
            selector_color_option_background: cs_common_background_surface_primary,
        },
        space: {
            space_size_child_element_space: 8,
        },
        divider: {
            divider_background_color_light: cs_common_background_divider_secondary,
            divider_background_color_gray: cs_common_background_divider_primary,
            divider_width: '100%',
            divider_height: 8,
        },
        checklist: {
            checklist_text_color: cs_common_text_title,
            checklist_text_active_color: cs_common_text_main,
            checklist_text_font_size: 16,
            checklist_text_font_weight: font_weight_normal,
            checklist_text_line_height: 22,
            checklist_item_vertical_padding: 12,
            checklist_item_horizontal_padding: 19,
            checklist_background_color: cs_common_background_secondary,
            checklist_icon_radius: 16,
            checklist_icon_margin_left: 12,
            checklist_item_opacity: 0.5,
            checklist_icon_color: cs_common_tint_main,
            checklist_icon_size: 20,
            checklist_icon_wrap_width: 20,
            checklist_icon_wrap_height: 20,
        },
        searchbar: {
            // 颜色变量
            searchbar_color_input_text: cs_common_text_black,
            searchbar_color_input_placeholder: cs_common_text_primary,
            searchbar_color_input_selection_color: cs_common_tint_main,
            searchbar_color_back_icon_color: cs_common_background_shallowblack,
            searchbar_color_right_content_text: cs_common_text_black,
            // 尺寸变量
            searchbar_size_input_height: searchbar_size_input_height,
            searchbar_size_input_padding_horizontal: searchbar_size_input_padding_horizontal,
            searchbar_size_input_content_margin: searchbar_size_input_content_margin,
            searchbar_size_right_content_text: searchbar_size_right_content_text,
            searchbar_size_input_icon_margin: searchbar_size_input_icon_margin,
            searchbar_size_input_font: searchbar_size_input_font,
            // icon组件的自定义样式
            searchbar_size_search_icon_custom: searchbar_size_search_icon,
            searchbar_size_right_icon_custom: searchbar_size_right_icon,
        },
        tabs: {
            // color
            tab_color_slider: cs_common_tint_black,
            tab_color_active_text: cs_common_text_title,
            tab_color_text: cs_common_text_primary,
            tab_color_tab_bar_bg: cs_common_background_surface_primary,
            // size
            // 文字大小
            tab_size_text: tab_size_text,
            tab_size_text_primary: tab_size_text_primary,
            tab_size_text_primary_half: tab_size_text_primary_half,
            tab_size_text_secondary: tab_size_text_secondary,
            tab_size_tab_item_padding_horizontal: 12,
            tab_size_tab_item_padding_horizontal_primary: 12,
            tab_size_tab_item_padding_horizontal_primary_half: 12,
            tab_size_tab_item_padding_horizontal_secondary: 16,
            tab_size_tab_bar_height_primary: tab_size_tab_bar_height_primary,
            tab_size_tab_bar_height_primary_half: tab_size_tab_bar_height_primary_half,
            tab_size_tab_bar_height_secondary: tab_size_tab_bar_height_secondary,
            tab_size_slider_bottom: undefined,
            tab_size_slider_bottom_primary: 5,
            tab_size_slider_bottom_primaryHalf: 7,
            tab_size_slider_bottom_secondary: 4,
            tab_size_slider_height: tab_size_slider_height,
            tab_size_slider_border_radius: tab_size_slider_border_radius,
            tab_size_text_weight: tab_size_text_weight,
            tab_size_text_active_weight: tab_size_text_active_weight,
            tab_size_tab_bar_height: tab_size_tab_bar_height,
            tab_size_tab_bar_content_padding_bottom: 2,
            tab_content_width: undefined,
            tab_content_container_width: undefined,
        },
        // 步骤条
        steps: {
            // 容器背景色
            steps_color_container_background: cs_common_background_secondary,
            // 基础三种状态背景色
            steps_color_starting_background: cs_common_tint_main,
            steps_color_waiting_background: cs_common_background_switch,
            steps_color_error_background: cs_common_text_red_error,
            // 基础四种状态文字色
            steps_color_process_text_color: cs_common_text_main,
            steps_color_waiting_text_color: cs_common_text_secondary,
            steps_color_finish_text_color: cs_common_text_title,
            steps_color_error_text_color: cs_common_text_red_error,
            // 节点画板框宽度
            steps_size_node_width: 24,
            // 节点画板框高度
            steps_size_node_height: 24,
            // 点状节点宽度
            steps_size_dot_width: 8,
            // 点状节点高度
            steps_size_dot_height: 8,
            // 点状圆角大小
            steps_size_dot_border_radius: 4,
            // 数字型节点宽度
            steps_size_number_width: 16,
            // 数字型节点高度
            steps_size_number_height: 16,
            // 数字型节点圆角
            steps_size_number_border_radius: 8,
            // 数字型节点字体大小
            steps_size_number_text_font_size: 12,
            // 数字型节点文字行高
            steps_size_number_text_line_height: 16,
            // 数字型节点文字颜色
            steps_color_number_text_color: cs_common_text_mainbutton,
            // icon 型节点宽度
            steps_size_icon_width: 16,
            // icon 型节点高度
            steps_size_icon_height: 16,
            // icon 型节点圆角大小
            steps_size_icon_border_radius: 8,
            // 节点连接线宽度(仅纵向生效)
            steps_size_step_line_width: 1,
            // 节点连接线高度(仅横向生效)
            steps_size_step_line_height: 1,
            // 节点连接线垂直边距(仅纵向生效)
            steps_size_step_line_margin_vertical: 4,
            // 节点连接线水平边距(仅横向生效)
            steps_size_step_line_margin_horizontal: 8,
            // 描述区左边距(仅纵向生效)
            steps_size_content_margin_left: 16,
            // desc上边距
            steps_size_desc_margin_top: 4,
            // desc下边距(仅纵向生效)
            steps_size_desc_margin_bottom: 16,
            // desc 字体大小
            steps_size_desc_font_size: 13,
            // desc 行高
            steps_size_desc_line_height: 18,
            // desc 字体色
            steps_color_desc_color: cs_common_text_secondary,
            // title 字体大小
            steps_size_title_font_size: 16,
            // title 行高
            steps_size_title_line_height: 22,
            // title 字体色
            steps_color_title_color: cs_common_text_title,
        },
        // 稳步域
        textarea: {
            // 颜色变量
            textarea_color_background: cs_common_background_surface_primary,
            textarea_color_background_gray: cs_common_background_primary,
            textarea_color_content_font: cs_common_text_title,
            textarea_color_text_length_font: cs_common_text_least,
            textarea_color_border: cs_common_stroke_primary,
            textarea_color_word_limit_font: cs_common_tint_red,
            textarea_color_placeholder_font: cs_common_text_secondary,
            // 尺寸变量
            textarea_size_default_height: textarea_size_container_default_height,
            textarea_size_default_width: textarea_size_container_default_width,
            textarea_size_container_default_line_height: textarea_size_container_default_line_height,
            textarea_size_length_counter_height: textarea_size_counter_height,
            textarea_size_counter_margin_top: textarea_size_counter_margin_top,
            textarea_size_text_font: font_grade_7,
            textarea_size_text_weight: font_weight_normal,
            textarea_size_text_padding_left: textarea_size_padding_left,
            textarea_size_text_padding_right: textarea_size_padding_right,
            textarea_size_text_padding_top: textarea_size_padding_top,
            textarea_size_text_padding_bottom: textarea_size_padding_bottom,
            textarea_size_border_radius: textarea_size_border_radius,
        },
        // 下拉菜单
        dropdown: {
            dropdown_nav_item_active_text_color: cs_common_text_main,
            dropdown_nav_item_active_font_weight: '500',
            dropdown_nav_item_text_color: cs_common_text_primary,
            dropdown_nav_item_text_font_weight: '400',
            dropdown_nav_item_text_font_size: 14,
            dropdown_nav_item_text_line_height: 20,
            dropdown_nav_item_padding_horizontal: 4,
            dropdown_nav_item_icon_margin_left: 2,
            dropdown_nav_background_color: cs_common_background_secondary,
            dropdown_popup_content_background_color: cs_common_background_secondary,
            dropdown_popup_content_border_bottom_radius: 16,
            dropdown_nav_height: 44,
            dropdown_nav_item_icon_width: 12,
            dropdown_nav_item_icon_height: 12,
        },
    };
};
